import { useOnInputHook } from 'src/hooks/useOnInput.hook'
import { ChangeEvent, forwardRef, KeyboardEvent } from 'react'
import styled, { css } from 'styled-components'
import { COLOR } from 'src/constants/colors'

export type InputPropsType = {
  $border?: string
  width?: string
  height?: string
  placeholder?: string
  $padding?: string
  value: string | number
  type?: string
  autoFocus?: boolean
  disabled?: boolean
  onBlur?: any
  option: InputPropsTypeOption
  onKeyDown?: (e: KeyboardEvent<HTMLImageElement>) => void
  style?: any
}
export type InputPropsTypeOption =
  | 'unLockDevice_modal'
  | 'deleteData_modal'
  | 'email'
  | 'login_pin'
  | 'emergency_contact'
  | 'reset_create_pin'
  | 'reset_confirm_pin'

const Input = forwardRef((props: InputPropsType, forwardedRef?: React.Ref<HTMLInputElement>) => {
  const oninput = useOnInputHook()
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    oninput.setValidFunc(e, props.option)
  }
  return (
    <InputWrap
      {...props}
      ref={forwardedRef}
      type={props.type ?? 'text'}
      onInput={handleInputChange}
      onBlur={props.onBlur}
      value={props.value}
      placeholder={props.placeholder}
      autoFocus={props.autoFocus}
      disabled={props.disabled}
      style={props.style}
    />
  )
})

export default Input

const InputWrap = styled.input<InputPropsType>`
  background: ${COLOR.white};
  border: ${(props) => props.$border || `1px solid ${COLOR.black20}`};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  padding: ${(props) => props.$padding || 0};
  color: ${COLOR.black100};
  border-radius: 12px;

  ${(props) =>
    (props.option === 'email' ||
      props.option === 'login_pin' ||
      props.option === 'deleteData_modal' ||
      props.option === 'unLockDevice_modal' ||
      props.option === 'reset_create_pin' ||
      props.option === 'emergency_contact' ||
      props.option === 'reset_confirm_pin') &&
    css`
      width: 100%;
      padding: 0 16px;
      height: 51px;
      line-height: 51px;
      border-radius: 12px;
      font-size: 16px;
    `};

  &:disabled {
    background: ${COLOR.black2};
  }
`
